<template>
  <div :class="$style.signatureWrapper">
    <!--[if mso | IE]>
    <table align="left"
           border="0"
           cellpadding="0"
           cellspacing="0"
           class=""
           role="presentation"
           style="width:600px;"
           width="600">
    <tr>
      <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px;max-width:600px;">
      <table align="left"
             border="0"
             cellpadding="0"
             cellspacing="0"
             role="presentation"
             style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;text-align:left;">
              <!--[if mso | IE]>
              <table role="presentation"
                     border="0"
                     cellpadding="0"
                     cellspacing="0">
              <tr>
                <td class=""
                    style="vertical-align:top;width:600px;"><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix"
                   style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0"
                       cellpadding="0"
                       cellspacing="0"
                       role="presentation"
                       style="vertical-align:top;"
                       width="100%">
                  <tbody>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;word-break:break-word;">
                        <div style="font-family:Arial,sans-serif;font-size:13px;font-weight:bold;line-height:1;text-align:left;color:#0076ff;">{{ person.firstName }} {{ person.lastName }}<span style="color:#272e3c; font-size:9px; font-weight:normal"
                                                                                                                                                                                                 v-if="person.pronoun !== 'none'">&nbsp;{{ person.pronoun }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;padding-top:2px;word-break:break-word;">
                        <div style="font-family:Arial,sans-serif;font-size:9px;font-weight:bold;line-height:1;text-align:left;color:#272e3c;">{{ person.title }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table>
  <table align="left"
         border="0"
         cellpadding="0"
         cellspacing="0"
         class=""
         role="presentation"
         style="width:600px;"
         width="600"
         v-if="!!office">
  <tr>
    <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px;max-width:600px;"
         v-if="!!office">
      <table align="left"
             border="0"
             cellpadding="0"
             cellspacing="0"
             role="presentation"
             style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;padding-top:15px;text-align:left;">
              <!--[if mso | IE]>
              <table role="presentation"
                     border="0"
                     cellpadding="0"
                     cellspacing="0">
              <tr>
                <td class=""
                    style="vertical-align:top;width:600px;"><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix"
                   style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0"
                       cellpadding="0"
                       cellspacing="0"
                       role="presentation"
                       style="vertical-align:top;"
                       width="100%">
                  <tbody>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;word-break:break-word;">
                        <div style="font-family:Arial,sans-serif;font-size:9px;line-height:11px;text-align:left;color:#272e3c;">
                          <span v-if="!!office.headquarters">GO2 Headquarters<br/></span>{{ office.street }}
                          <br/>
                          {{ office.city }}, {{ office.state }} {{ office.zip }}
                          <br/>
                          <template v-if="hasPhone">
                            <template
                              v-for="(phone, index) in person.phones">
                              <template v-if="phone.phoneNumber != '' || phone.phoneType != ''">
                                            <span
                                              :key="`${index}-0`">{{
                                                formatType(phone.phoneType)
                                              }} </span><span
                                :key="`${index}-1`">{{ formatNumber(phone.phoneNumber) }}<br></span>
                              </template>
                            </template>
                          </template>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table>
  <table align="left"
         border="0"
         cellpadding="0"
         cellspacing="0"
         class=""
         role="presentation"
         style="width:600px;"
         width="600">
  <tr>
    <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px;max-width:600px;">
      <table align="left"
             border="0"
             cellpadding="0"
             cellspacing="0"
             role="presentation"
             style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;text-align:left;">
              <!--[if mso | IE]>
              <table role="presentation"
                     border="0"
                     cellpadding="0"
                     cellspacing="0">
              <tr>
                <td class=""
                    style="vertical-align:top;width:600px;"><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix"
                   style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0"
                       cellpadding="0"
                       cellspacing="0"
                       role="presentation"
                       style="vertical-align:top;"
                       width="100%">
                  <tbody>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;word-break:break-word;">
                        <div style="font-family:Arial,sans-serif;font-size:9px;line-height:1;text-align:left;color:#272e3c;">
                          <a :href="`mailto:${person.email}`"
                             style="color:#272e3c;">{{ person.email }}</a></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table>
  <table align="left"
         border="0"
         cellpadding="0"
         cellspacing="0"
         class=""
         role="presentation"
         style="width:600px;"
         width="600"
         v-if="hasMeetingLink">
  <tr>
    <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div
      v-if="hasMeetingLink"
      style="margin:0px;max-width:600px;"
    >
      <table align="left"
             border="0"
             cellpadding="0"
             cellspacing="0"
             role="presentation"
             style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;padding-top:12px;text-align:left;">
              <!--[if mso | IE]>
              <table role="presentation"
                     border="0"
                     cellpadding="0"
                     cellspacing="0">
              <tr>
                <td class=""
                    style="vertical-align:top;width:600px;"><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix"
                   style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0"
                       cellpadding="0"
                       cellspacing="0"
                       role="presentation"
                       style="vertical-align:top;"
                       width="100%">
                  <tbody>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;word-break:break-word;">
                        <div style="font-family:Arial,sans-serif;font-size:9px;font-weight:bold;line-height:1;text-align:left;color:#272e3c;">
                          <a :href="`https://www.go2partners.com/meetings/${person.meetingLink}/meeting`"
                             style="color:#272e3c;">Book a meeting with {{ person.firstName }}</a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table>
  <table align="left"
         border="0"
         cellpadding="0"
         cellspacing="0"
         class=""
         role="presentation"
         style="width:600px;"
         width="600">
  <tr>
    <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px;max-width:600px;">
      <table align="left"
             border="0"
             cellpadding="0"
             cellspacing="0"
             role="presentation"
             style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;padding-top:15px;text-align:left;">
              <!--[if mso | IE]>
              <table role="presentation"
                     border="0"
                     cellpadding="0"
                     cellspacing="0">
              <tr>
                <td class=""
                    style="vertical-align:top;width:600px;"><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix"
                   style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0"
                       cellpadding="0"
                       cellspacing="0"
                       role="presentation"
                       style="vertical-align:top;"
                       width="100%">
                  <tbody>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;word-break:break-word;">
                        <table border="0"
                               cellpadding="0"
                               cellspacing="0"
                               role="presentation"
                               style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:124px;">
                                <img height="23"
                                     :src="imageUrl"
                                     style="border:0;display:block;outline:none;text-decoration:none;height:23px;width:100%;font-size:13px;"
                                     width="124"/>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;padding-top:12px;word-break:break-word;">
                        <div style="font-family:Arial,sans-serif;font-size:9px;font-weight:bold;line-height:1;text-align:left;color:#272e3c;">
                          <a href="https://www.go2partners.com"
                             style="color:#272e3c; text-decoration:none;">go2partners.com</a>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table>
  <table align="left"
         border="0"
         cellpadding="0"
         cellspacing="0"
         class=""
         role="presentation"
         style="width:600px;"
         width="600">
  <tr>
    <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px;max-width:600px;">
      <table align="left"
             border="0"
             cellpadding="0"
             cellspacing="0"
             role="presentation"
             style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;padding-top:10px;text-align:left;">
              <!--[if mso | IE]>
              <table role="presentation"
                     border="0"
                     cellpadding="0"
                     cellspacing="0">
              <tr>
                <td class=""
                    style="vertical-align:top;width:600px;"><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix"
                   style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0"
                       cellpadding="0"
                       cellspacing="0"
                       role="presentation"
                       style="vertical-align:top;"
                       width="100%">
                  <tbody>
                    <tr>
                      <td align="justify"
                          style="font-size:0px;padding:0;word-break:break-word;">
                        <div style="font-family:Arial,sans-serif;font-size:6px;line-height:1;text-align:justify;color:#272e3c;">{{ division.disclaimer }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table>
  <table align="left"
         border="0"
         cellpadding="0"
         cellspacing="0"
         class=""
         role="presentation"
         style="width:600px;"
         width="600"
         v-if="hasSocial">
  <tr>
    <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;"><![endif]-->
    <div style="margin:0px;max-width:600px;"
         v-if="hasSocial">
      <table align="left"
             border="0"
             cellpadding="0"
             cellspacing="0"
             role="presentation"
             style="width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:0;padding-top:15px;text-align:left;">
              <!--[if mso | IE]>
              <table role="presentation"
                     border="0"
                     cellpadding="0"
                     cellspacing="0">
              <tr>
                <td class=""
                    style="vertical-align:top;width:600px;"><![endif]-->
              <div class="mj-column-per-100 mj-outlook-group-fix"
                   style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0"
                       cellpadding="0"
                       cellspacing="0"
                       role="presentation"
                       style="vertical-align:top;"
                       width="100%">
                  <tbody>
                    <tr>
                      <td align="left"
                          style="font-size:0px;padding:0;word-break:break-word;">
                        <!--[if mso | IE]>
                        <table align="left"
                               border="0"
                               cellpadding="0"
                               cellspacing="0"
                               role="presentation">
                        <tr>
                          <td v-if="hasFacebook"><![endif]-->
                        <table align="left"
                               border="0"
                               cellpadding="0"
                               cellspacing="0"
                               role="presentation"
                               style="float:none;display:inline-table;"
                               v-if="hasFacebook">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0"
                                       cellpadding="0"
                                       cellspacing="0"
                                       role="presentation"
                                       style="background:#3b5998;border-radius:3px;width:18px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:18px;vertical-align:middle;width:18px;">
                                        <a href="https://www.facebook.com/sharer/sharer.php?u=https://www.facebook.com/go2partners"" target="_blank">
                                        <img height="18"
                                             src="https://www.mailjet.com/images/theme/v1/icons/ico-social/facebook.png"
                                             style="border-radius:3px;display:block;"
                                             width="18"/> </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!--[if mso | IE]></td>
                      <td v-if="hasLinkedIn"><![endif]-->
                        <table align="left"
                               border="0"
                               cellpadding="0"
                               cellspacing="0"
                               role="presentation"
                               style="float:none;display:inline-table;"
                               v-if="hasLinkedIn">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0"
                                       cellpadding="0"
                                       cellspacing="0"
                                       role="presentation"
                                       style="background:#0077b5;border-radius:3px;width:18px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:18px;vertical-align:middle;width:18px;">
                                        <a href="https://www.linkedin.com/shareArticle?mini=true&url=https://www.linkedin.com/company/go2partners&title=&summary=&source="
                                           target="_blank"> <img height="18"
                                                                 src="https://www.mailjet.com/images/theme/v1/icons/ico-social/linkedin.png"
                                                                 style="border-radius:3px;display:block;"
                                                                 width="18"/> </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!--[if mso | IE]></td>
                      <td v-if="hasInstagram"><![endif]-->
                        <table align="left"
                               border="0"
                               cellpadding="0"
                               cellspacing="0"
                               role="presentation"
                               style="float:none;display:inline-table;"
                               v-if="hasInstagram">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0"
                                       cellpadding="0"
                                       cellspacing="0"
                                       role="presentation"
                                       style="background:#3f729b;border-radius:3px;width:18px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:18px;vertical-align:middle;width:18px;">
                                        <a href="https://www.instagram.com/go2partners/"
                                           target="_blank"> <img height="18"
                                                                 src="https://www.mailjet.com/images/theme/v1/icons/ico-social/instagram.png"
                                                                 style="border-radius:3px;display:block;"
                                                                 width="18"/> </a>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <!--[if mso | IE]></td></tr></table><![endif]-->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!--[if mso | IE]></td></tr></table><![endif]-->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!--[if mso | IE]></td></tr></table><![endif]-->
  </div>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */
import offices from 'src/data/offices';

export default {
  name: 'Signature',
  props: {
    division: {
      type: Object,
      required: true,
    },
    person: {
      type: Object,
      required: true,
    },
    hasPhone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      offices,
      office: null,
    };
  },
  computed: {
    imageUrl() {
      return `${location.href.replace(/#.*/, '')}images/emailLogos/${
        this.division.emailLogo
      }`;
    },
    hasFacebook() {
      return this.person.socials.includes('fb');
    },
    hasInstagram() {
      return this.person.socials.includes('ig');
    },
    hasLinkedIn() {
      return this.person.socials.includes('li');
    },
    hasSocial() {
      return this.hasFacebook || this.hasLinkedIn || this.hasInstagram;
    },
    hasMeetingLink() {
      if (this.person.meetingLink) {
        return true;
      }
      return false;
    },
  },
  watch: {
    'person.office'() {
      this.office = offices.find(
        (office) => office.name === this.person.office,
      );
    },
  },
  methods: {
    formatNumber(s) {
      let s2 = ('' + s).replace(/\D/g, '');
      let m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
      return !m ? s2 : m[1] + ' ' + m[2] + ' ' + m[3];
    },
    formatType(value) {
      return value.substring(0, 1);
    },
  },
};
</script>
<style lang="scss" module>
@import 'src/brand/brandColors.variables';

.fontStack {
  font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
}

.signatureWrapper {
  max-width: 600px;
}
</style>
